import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  PlacesProvider,
  getExcludes,
  getChilds
} from '../../dataProvider/places';
import Autocomplete from '../../components/autocomplete';
import { getRoute } from '../../utils';
import { nearestTownRest } from '../../dataProvider/places/nearestTown';

const setSelectedsByParent = (
  location,
  excludes,
  selectedPlaces,
  setSelectedPlaces
) => {
  Promise.all([
    nearestTownRest(
      location.ineId,
      location.location.lat,
      location.location.lon
    ),
    getChilds(
      location.typePlace === 'REGION' ? 'PROVINCE' : 'TOWN',
      location.ineId
    )
  ]).then(([{ data: nears }, childs]) => {
    setSelectedPlaces({
      ...selectedPlaces,
      hijos:
        childs && childs.content
          ? childs.content.map(place => {
              return { ...place, href: getRoute(place, true, excludes) };
            })
          : [],
      cercanos:
        nears && nears.content
          ? nears.content.map(place => {
              return { ...place, href: getRoute(place, true, excludes) };
            })
          : []
    });
  });
};

const ButtonGenerator = ({
  navegable,
  type,
  electionType,
  location,
  electionName
}) => {
  console.log({ navegable, type, electionType, location, electionName });
  const [mode, setMode] = useState('manual');
  const [autocomple, setAutocomple] = useState('manual');
  const [excludes, setExcludes] = useState(null);
  const preElAmp = useRef(null);
  const preEl = useRef(null);

  const [selectedPlaces, setSelectedPlaces] = useState({
    manual: [],
    cercanos: [],
    hijos: []
  });
  useEffect(() => {
    if (location) {
      setSelectedsByParent(
        location,
        excludes,
        selectedPlaces,
        setSelectedPlaces
      );
    }
    getExcludes().then(_excludes => {
      setExcludes(_excludes);
    });
  }, []);
  useEffect(() => {
    if (location) {
      setSelectedsByParent(
        location,
        excludes,
        selectedPlaces,
        setSelectedPlaces
      );
    }
  }, [location]);

  const addPlace = place => {
    setAutocomple('');
    if (!selectedPlaces[mode].some(p => p.ineId === place.ineId)) {
      setSelectedPlaces({
        ...selectedPlaces,
        [mode]: [
          ...selectedPlaces[mode],
          { ...place, href: getRoute(place, true, excludes) }
        ]
      });
    }
  };
  const removePlace = place => {
    setAutocomple('');

    setSelectedPlaces({
      ...selectedPlaces,
      [mode]: selectedPlaces[mode].filter(item => item.ineId !== place.ineId)
    });
  };

  return (
    <div className="containerel">
      <div className="flex-container ">
        <div className="flex-row center">
          <button
            className={`button-gen ${mode === 'manual' && 'selected'}`}
            onClick={() => setMode('manual')}
          >
            Manual
          </button>
          {location && location.typePlace === 'TOWN' && (
            <button
              className={`button-gen ${mode === 'cercanos' && 'selected'}`}
              onClick={() => setMode('cercanos')}
            >
              Cercanos
            </button>
          )}
          <button
            className={`button-gen ${mode === 'hijos' && 'selected'}`}
            onClick={() => setMode('hijos')}
          >
            Hijos
          </button>
        </div>

        {mode === 'manual' && (
          <Fragment>
            <div className="flex-row center">
              <div className="m10 w200">
                <PlacesProvider name={autocomple} type="TOWN">
                  {data => {
                    return (
                      <Autocomplete
                        results={data}
                        onChange={value => setAutocomple(value)}
                        onSelect={addPlace}
                        placeholder={'Busque municipio'}
                        showArrow
                      />
                    );
                  }}
                </PlacesProvider>
              </div>

              <div className="m10 w200">
                <PlacesProvider name={autocomple} type="PROVINCE">
                  {data => {
                    return (
                      <Autocomplete
                        results={data}
                        onChange={value => setAutocomple(value)}
                        onSelect={addPlace}
                        placeholder={'Busque provincia'}
                        showArrow
                      />
                    );
                  }}
                </PlacesProvider>
              </div>

              <div className="m10 w200">
                <PlacesProvider name={autocomple} type="REGION">
                  {data => {
                    return (
                      <Autocomplete
                        results={data}
                        onChange={value => setAutocomple(value)}
                        onSelect={addPlace}
                        placeholder={'Busque CCAA'}
                        showArrow
                      />
                    );
                  }}
                </PlacesProvider>
              </div>
            </div>
          </Fragment>
        )}
        <div className="row">
          <div className="w20 mh left list">
            <ol className="border">
              {selectedPlaces[mode].map(item => (
                <li key={item.ineId}>
                  <p>
                    <button
                      className="button "
                      onClick={() => {
                        removePlace(item);
                      }}
                    >
                      X
                    </button>{' '}
                    {item.name}
                  </p>
                </li>
              ))}
            </ol>
          </div>
          <div className="w20 mh left ">
            <pre className="border scroll" ref={preEl}>
              {selectedPlaces[mode].reduce(
                (total, item) =>
                  total +
                  `<li><a class="tags-list__link btn btn-secondary"  title="${item.ineId}" href="${item.href}" > ${item.name} </a></li>
`,
                '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
              ) + `</ul></div>`}
            </pre>
            <button
              className="button  fixed-btn"
              onClick={el => {
                const range = document.createRange();
                range.selectNodeContents(preEl.current);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
                document.execCommand('copy');
                sel.removeRange(range);
              }}
            >
              {' '}
              Copiar
            </button>
          </div>
          <div className="w20 mh left ">
            <pre className="border scroll" ref={preElAmp}>
              {selectedPlaces[mode].reduce(
                (total, item) =>
                  total +
                  `<li><a class="tags-list__link btn btn-secondary"  title="${
                    item.ineId
                  }" href="${item.href.replace('www.', 'amp.')}"  > ${
                    item.name
                  } </a></li>
`,
                '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
              ) + `</ul></div>`}
            </pre>
            <button
              className="button  fixed-btn"
              onClick={el => {
                const range = document.createRange();
                range.selectNodeContents(preElAmp.current);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
                document.execCommand('copy');
                sel.removeRange(range);
              }}
            >
              {' '}
              Copiar AMP
            </button>
          </div>

          <div className="w40 mh left border">
            {selectedPlaces[mode].map(item => (
              <a
                key={item.ineId}
                href={item.href}
                type="button"
                className="tag"
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonGenerator;
